import React from 'react'
import { Stack } from '@mui/material'
import { useGlobalState } from 'state'
import { Legend } from 'common/types'
import { LegendPanel } from './LegendControl'
import { isMobileOnly } from 'react-device-detect'
import { LAYERS } from 'common/layers'
import { HazardMaps } from 'common/hazardmaps'


export const HazardMapLegendControl = () => {
  const state = useGlobalState()
  const alignItems = isMobileOnly ? 'flex-start' : 'flex-end'
  const direction = isMobileOnly ? 'column' : 'row'
  const legends = React.useMemo(() => {
    const result = [ ...state.app.hazardMapLegends ]
    if (state.app.estimatedFloodingLayers.includes(LAYERS.EF_SHINSUISOUTEI_COLOR.id)) {
      if (!result.includes(HazardMaps[0].legends[0])) {
        result.push(HazardMaps[0].legends[0])
      }
    }
    return result
  }, [state.app.hazardMapLegends, state.app.estimatedFloodingLayers])

  return (
    <Stack direction={direction} alignItems={alignItems} spacing={1}>
      {
        legends.map((legend: Legend, index: number) => {
          return <LegendPanel legend={legend} key={index} />
        })
      }
    </Stack>
  )
}
